<!-- Error message -->
<div *ngIf="apiError">
    <div *ngIf="apiError.message" class="px-4 py-3 rounded-lg mb-4 fade show error-container mx-auto px-4 mx-auto px-4" [ngClass]="alertClass" role="alert">
        <button class="close" (click)="onClickClose()">
            <i class="material-icons">close</i>
        </button>
        <span>{{ apiError.message }}</span>
        <div *ngIf="apiError.fieldErrors">
            <ul>
                <li *ngFor="let fieldError of apiError.fieldErrors">
                    {{fieldError.message}}
                </li>
            </ul>
        </div>
    </div>
</div>